import debounce from 'lodash/debounce';
import { useCallback, useEffect, useState } from 'react';

const scrollRestoration = {};

const useScrollRestoration = (key) => {
  const [element, setElement] = useState(null);
  const ref = useCallback((el) => {
    if (el) {
      setElement(el);
    }
  }, []);

  const currentScrollRestoration = scrollRestoration[key];
  const hasRestoration = key in scrollRestoration;

  useEffect(() => {
    if (!element) return;

    const handleScroll = debounce(() => {
      const { scrollTop, scrollLeft } = element;
      scrollRestoration[key] = { scrollTop, scrollLeft };
    }, 100);

    element.addEventListener('scroll', handleScroll);
    // eslint-disable-next-line consistent-return
    return () => {
      element.removeEventListener('scroll', handleScroll);
    };
  }, [key, element]);

  useEffect(() => {
    if (!element) return;

    if (!hasRestoration) {
      scrollRestoration[key] = {
        scrollTop: element.scrollTop,
        scrollLeft: element.scrollLeft,
      };

      return;
    }

    element.scrollTo(
      currentScrollRestoration.scrollLeft,
      currentScrollRestoration.scrollTop,
    );
  }, [currentScrollRestoration, element, key, hasRestoration]);

  return { ref };
};

export default useScrollRestoration;
